import React from 'react';
import { siteData } from '../../data/mock';

const ThreeSteps = () => {
  const { threeSteps } = siteData;

  return (
    <section className="py-[60px] md:py-[80px] bg-[#f7f8fc]">
      <div className="max-w-[1200px] mx-auto px-4 sm:px-6">
        <h2 className="text-[28px] md:text-[34px] font-bold text-center text-[#1a1a2e] mb-10 md:mb-14 leading-tight">
          {threeSteps.title}
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {threeSteps.steps.map((step, index) => (
            <div
              key={index}
              className="bg-white rounded-xl p-6 md:p-8 shadow-sm hover:shadow-md transition-shadow duration-300"
            >
              <h3 className="text-[18px] md:text-[20px] font-bold text-[#1a1a2e] mb-4 leading-snug">
                {step.title}
              </h3>
              <p className="text-[14px] md:text-[15px] text-[#4a4a6a] leading-[1.8]">
                {step.text}
              </p>
            </div>
          ))}
        </div>

        <div className="text-center mt-8 md:mt-12">
          <a
            href="#form-main"
            className="inline-block px-8 py-3.5 bg-[#0E47B0] hover:bg-[#0d3d96] text-white font-bold text-sm tracking-wider rounded-lg transition-colors no-underline"
          >
            {threeSteps.ctaText}
          </a>
        </div>
      </div>
    </section>
  );
};

export default ThreeSteps;
